<script setup lang="ts">
import { computed } from 'vue'
import type { UserTrialStatusChipKollegeUserFragment } from './UserTrialStatusChip.generated'

const props = defineProps<{
  user: UserTrialStatusChipKollegeUserFragment
}>()

type Chip = {
  text: string
  color: 'red' | 'green' | 'blue' | 'gray'
}

// 受講完了の場合は「コース未申込」と同じステータスなので表示しない
const completed =
  props.user.trials.length > 0 &&
  props.user.trials.every(trial => trial.status === 'Completed')

const userTrialStatusChip = computed((): Chip => {
  // 体験会の日時が決まっていない場合
  if (
    props.user.trials.length === 0 ||
    props.user.trials.some(trial => trial.status === 'UnBooked')
  ) {
    return { text: '無料体験未予約', color: 'red' }
  }

  if (props.user.trials.some(trial => trial.status === 'Booked')) {
    return { text: '無料体験予約中', color: 'green' }
  }

  // 表示されないけど状態としては存在するので一応残しておく
  if (props.user.trials.every(trial => trial.status === 'Completed')) {
    return { text: '無料体験受講済み', color: 'gray' }
  }

  return { text: '不明なステータス', color: 'gray' }
})
</script>

<template>
  <span
    v-if="!completed"
    :class="[$style.chip, $style[`chip--${userTrialStatusChip.color}`]]"
  >
    {{ userTrialStatusChip.text }}
  </span>
</template>

<style lang="scss" module>
.chip {
  border-radius: 100vmax;
  padding: 6px 12px 8px;
  line-height: 1;
  color: $color-text-and-object-high-emphasis-inverse;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;

  &--red {
    background-color: $color-label-red;
  }

  &--green {
    background-color: $color-label-green;
  }

  &--blue {
    background-color: $color-label-blue;
  }

  &--gray {
    background-color: $color-label-gray;
  }
}
</style>
